import { useCallback, useEffect, useState } from 'react';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { logError } from '../../../../utils/logger';
import { SectionTitle, SegmentedControl } from '../../../shared/components';
import EmployeesTable from '../components/EmployeesTable';
import { getAllEmployees } from '../employees.service';

const DEFAULT_STATUS = 'active';
const STATUS_FILTERS = [
  { label: 'Active Employees', value: 'active' },
  { label: 'In-Active Employees', value: 'inactive' },
];

export default function EmployeesPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState({});

  const status = searchParams.get('status') || DEFAULT_STATUS;

  const handleStatusChange = (val) => {
    if (val === status) return;
    navigate(`/employees?status=${val}`, { replace: true });
  };

  const fetchAllEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAllEmployees();
      setEmployees(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch employees',
          error: err,
          code: 'EMPLOYEE_LIST_FETCH_FAILED',
        })
      );
      setEmployees({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAllEmployees();
  }, [fetchAllEmployees]);

  return (
    <div className='column gap-5'>
      <SegmentedControl options={STATUS_FILTERS} value={status} onChange={(v: string) => handleStatusChange(v)} />
      <SectionTitle title='EMPLOYEES' />
      <EmployeesTable employeesData={employees} status={status} loading={loading} />
      <Outlet />
    </div>
  );
}
